import { ReactNode } from "react"

type Props = {
  title?: ReactNode
  subtitle?: ReactNode
}

export function PageTitle(props: Props) {
  return (
    <div className="stack-y-1 pb-6">
      <h1 className="type-title-l-medium">{props.title}</h1>
      {!!props.subtitle && <p className="type-title-l-roman">{props.subtitle}</p>}
    </div>
  )
}
